var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatarMaterialAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 8C20.0373 8 17.4093 10.9693 16 13.176C14.5907 10.9693 11.9627 8 8 8C5.87827 8 3.84344 8.84285 2.34315 10.3431C0.842855 11.8434 0 13.8783 0 16C0 18.1217 0.842855 20.1566 2.34315 21.6569C3.84344 23.1571 5.87827 24 8 24C11.9627 24 14.5907 21.0307 16 18.824C17.4093 21.0307 20.0373 24 24 24C26.1217 24 28.1566 23.1571 29.6569 21.6569C31.1571 20.1566 32 18.1217 32 16C32 13.8783 31.1571 11.8434 29.6569 10.3431C28.1566 8.84285 26.1217 8 24 8ZM8 21.3333C6.58551 21.3333 5.22896 20.7714 4.22876 19.7712C3.22857 18.771 2.66667 17.4145 2.66667 16C2.66667 14.5855 3.22857 13.229 4.22876 12.2288C5.22896 11.2286 6.58551 10.6667 8 10.6667C11.5907 10.6667 13.8427 14.5933 14.5333 16C13.848 17.4133 11.6107 21.3333 8 21.3333ZM24 21.3333C20.4093 21.3333 18.1573 17.4067 17.4667 16C18.1533 14.5893 20.3907 10.6667 24 10.6667C25.4145 10.6667 26.771 11.2286 27.7712 12.2288C28.7714 13.229 29.3333 14.5855 29.3333 16C29.3333 17.4145 28.7714 18.771 27.7712 19.7712C26.771 20.7714 25.4145 21.3333 24 21.3333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarMaterialAll);
export default __webpack_public_path__ + "static/media/avatar-material-all.4b646af599aec16c9b2c3617cff6a80f.svg";
export { ForwardRef as ReactComponent };